/* FDC quick-add for cart suggestions and "complete the set" */
import { CartLinesUpdateEvent } from '@shopify/events';
if (!window.__fdcQuickAdd) {
  window.__fdcQuickAdd = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-fdc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const id = Number(btn.dataset.fdcAdd);
    const label = btn.innerHTML;
    btn.disabled = true; btn.classList.add('is-loading');
    let resolve, reject;
    const promise = new Promise((a, r) => { resolve = a; reject = r; });
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise }));
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-drawer-section', sections_url: location.pathname + location.search })
      }).then((r) => r.json());
      if (res.status) throw new Error(res.description || res.message || 'Could not add');
      const cart = await fetch('/cart.js').then((r) => r.json());
      resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: res.sections, items: res.items, source: 'fdc-quick-add' } });
      btn.innerHTML = 'Added ✓'; btn.classList.add('is-added');
      if (btn.dataset.openCart) {
        const d = document.querySelector('#cart-drawer');
        if (d && typeof d.showDialog === 'function') d.showDialog();
        else document.querySelector('[data-cart-drawer-trigger], .header-actions__cart-icon, a[href$="/cart"]')?.click();
      }
    } catch (err) {
      reject(err);
      btn.innerHTML = 'Try again'; btn.disabled = false;
      setTimeout(() => { btn.innerHTML = label; }, 2000);
    } finally { btn.classList.remove('is-loading'); }
  });
}

/* FDC "Make it a gift": gift wrap, printed letter, rush dispatch */
if (!window.__fdcGift) {
  window.__fdcGift = true;
  const SECTIONS = 'cart-drawer-section';
  const box = () => document.querySelector('#cart-drawer .fdc-gift') || document.querySelector('.fdc-gift');
  let busy = false;

  const withSections = (body) => Object.assign(body, { sections: SECTIONS, sections_url: location.pathname + location.search });

  async function run(label, request) {
    busy = true;
    const el = box(); el?.classList.add('is-busy');
    let resolve, reject;
    const promise = new Promise((a, r) => { resolve = a; reject = r; });
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise }));
    try {
      const res = await request();
      if (res.status && res.status >= 400 || res.errors) throw new Error(res.description || res.message || res.errors || 'Something went wrong');
      const cart = await fetch('/cart.js').then((r) => r.json());
      resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: res.sections, source: 'fdc-gift-' + label } });
    } catch (err) {
      reject(err);
      const e = box()?.querySelector('.fdc-gift__err');
      if (e) { e.textContent = err.message || 'Something went wrong. Please try again.'; e.hidden = false; }
      throw err;
    } finally {
      busy = false; box()?.classList.remove('is-busy');
    }
  }

  const postJSON = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(withSections(body)) }).then((r) => r.json());
  const setQty = (variantId, qty) => postJSON('/cart/update.js', { updates: { [variantId]: qty } });
  const changeLine = (key, qty) => postJSON('/cart/change.js', { id: key, quantity: qty });

  // Toggles
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-fdc-toggle]');
    if (!t) return;
    const d = box().dataset, n = Number(d.items);
    const isRush = t.dataset.fdcToggle === 'rush';
    const qty = isRush ? Number(d.rushN ?? n) : n;
    if (isRush && !qty) { t.checked = false; return; }
    const id = isRush ? d.rushId : d.wrapId;
    run(t.dataset.fdcToggle, () => setQty(id, t.checked ? qty : 0)).catch(() => { t.checked = !t.checked; });
  });

  // Keep wrap and rush quantities equal to the number of items; remove add-ons when nothing else is left.
  // Rush dispatch covers only non-AOP items (data-rush-n); all-over print tees are excluded.
  function sync() {
    if (busy) return;
    const el = box(); if (!el) { cleanOrphans(); return; }
    const d = el.dataset, n = Number(d.items), updates = {};
    const rushTarget = Number(d.rushN ?? n);
    if (Number(d.wrapQ) > 0 && Number(d.wrapQ) !== n) updates[d.wrapId] = n;
    if (Number(d.rushQ) > 0 && Number(d.rushQ) !== rushTarget) updates[d.rushId] = rushTarget;
    if (Object.keys(updates).length) { run('sync', () => postJSON('/cart/update.js', { updates })).catch(() => {}); return; }
    if (Number(d.letterQ) > 1 && d.letterKey) { run('sync', () => changeLine(d.letterKey, 1)).catch(() => {}); return; }
    // Letter is free once the order passes ₹2,499: swap between the ₹79 and ₹0 variants, keeping the customer's letter
    if (d.letterKey && d.letterVariant && d.letterVariant !== d.letterId) {
      const properties = {};
      if (d.letterTo) properties.To = d.letterTo;
      if (d.letterMsg) properties.Message = d.letterMsg;
      if (d.letterFrom) properties.From = d.letterFrom;
      if (d.letterFile) properties['_Letter file'] = d.letterFile;
      run('sync', async () => {
        await changeLine(d.letterKey, 0);
        return postJSON('/cart/add.js', { items: [{ id: Number(d.letterId), quantity: 1, properties }] });
      }).catch(() => {});
    }
  }
  // Remember whether the shopper opened or closed "Make it a gift" across drawer re-renders
  document.addEventListener('toggle', (e) => { if (e.target.classList && e.target.classList.contains('fdc-gift')) window.__fdcGiftOpen = e.target.open; }, true);
  function keepOpen() {
    const el = box();
    if (el && typeof window.__fdcGiftOpen === 'boolean' && el.open !== window.__fdcGiftOpen) el.open = window.__fdcGiftOpen;
  }
  let syncT;
  const watch = () => { keepOpen(); clearTimeout(syncT); syncT = setTimeout(sync, 250); };
  const drawer = document.querySelector('#cart-drawer') || document.body;
  new MutationObserver(watch).observe(drawer, { childList: true, subtree: true });
  watch();

  // Orphaned add-ons (all real items removed): the gift box is not rendered, so check the cart directly
  let cleaning = false;
  async function cleanOrphans() {
    if (busy || cleaning) return;
    cleaning = true;
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const real = cart.items.filter((i) => i.product_type !== 'Add-on');
      const addons = cart.items.filter((i) => i.product_type === 'Add-on');
      if (!real.length && addons.length) {
        const updates = {}; addons.forEach((i) => { updates[i.variant_id] = 0; });
        await run('cleanup', () => postJSON('/cart/update.js', { updates }));
      }
    } catch (_) {} finally { cleaning = false; }
  }

  // Letter editor
  let dlg;
  const loadLetter = () => window.FDCLetter ? Promise.resolve() : new Promise((res, rej) => {
    const s = document.createElement('script'); s.src = box()?.dataset.asset; s.onload = res; s.onerror = () => rej(new Error('Could not load the letter designer'));
    document.head.appendChild(s);
  });

  function buildDialog() {
    dlg = document.createElement('dialog');
    dlg.className = 'fdc-letter';
    dlg.innerHTML = `
      <form method="dialog" class="fdc-letter__in">
        <div class="fdc-letter__head">
          <p class="fdc-letter__k">Printed letter · A5</p>
          <button type="button" class="fdc-letter__x" data-close aria-label="Close">✕</button>
        </div>
        <div class="fdc-letter__grid">
          <div class="fdc-letter__prev"><canvas aria-label="Letter preview"></canvas></div>
          <div class="fdc-letter__fields">
            <label>To <input name="to" maxlength="40" placeholder="Riya" autocomplete="off"></label>
            <label>Your message <textarea name="message" maxlength="400" rows="7" placeholder="Happy Diwali! …" required></textarea><span class="fdc-letter__count">0 / 400</span></label>
            <label>From <input name="from" maxlength="40" placeholder="Aarav" autocomplete="off"></label>
            <p class="fdc-letter__note">We print your letter exactly as it looks here, so check the spelling. Any language and emoji works.</p>
            <p class="fdc-letter__err" role="alert" hidden></p>
            <button type="submit" class="fdc-letter__save">Add letter to order</button>
          </div>
        </div>
      </form>`;
    document.body.appendChild(dlg);
    const f = dlg.querySelector('form'), cv = dlg.querySelector('canvas'), count = dlg.querySelector('.fdc-letter__count');
    let t;
    const paint = () => { clearTimeout(t); t = setTimeout(() => { window.FDCLetter.draw(cv, { to: f.to.value, message: f.message.value, from: f.from.value }); count.textContent = f.message.value.length + ' / 400'; }, 90); };
    f.addEventListener('input', paint);
    dlg.paint = paint;
    dlg.querySelector('[data-close]').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const err = dlg.querySelector('.fdc-letter__err'), btn = dlg.querySelector('.fdc-letter__save');
      const data = { to: f.to.value.trim(), message: f.message.value.trim(), from: f.from.value.trim() };
      if (!data.message) { err.textContent = 'Write a message first.'; err.hidden = false; f.message.focus(); return; }
      err.hidden = true; btn.disabled = true; btn.textContent = 'Creating your letter…';
      try {
        const blob = await window.FDCLetter.toBlob(data);
        const d = box().dataset, oldKey = d.letterKey;
        await run('letter', async () => {
          if (oldKey) await changeLine(oldKey, 0);
          const fd = new FormData();
          fd.append('id', d.letterId); fd.append('quantity', '1');
          if (data.to) fd.append('properties[To]', data.to);
          fd.append('properties[Message]', data.message);
          if (data.from) fd.append('properties[From]', data.from);
          fd.append('properties[_Letter file]', blob, 'fdc-letter.png');
          fd.append('sections', SECTIONS); fd.append('sections_url', location.pathname + location.search);
          return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }).then((r) => r.json());
        });
        dlg.close();
      } catch (ex) {
        err.textContent = ex.message || 'Could not add the letter. Please try again.'; err.hidden = false;
      } finally { btn.disabled = false; btn.textContent = 'Add letter to order'; }
    });
  }

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-fdc-letter]');
    if (!b) return;
    e.preventDefault();
    const d = box().dataset;
    if (b.dataset.fdcLetter === 'remove') { run('letter-remove', () => changeLine(d.letterKey, 0)).catch(() => {}); return; }
    try { await loadLetter(); } catch (ex) { return; }
    if (!dlg) buildDialog();
    const f = dlg.querySelector('form');
    f.to.value = b.dataset.fdcLetter === 'edit' ? (d.letterTo || '') : '';
    f.message.value = b.dataset.fdcLetter === 'edit' ? (d.letterMsg || '') : '';
    f.from.value = b.dataset.fdcLetter === 'edit' ? (d.letterFrom || '') : '';
    dlg.querySelector('.fdc-letter__err').hidden = true;
    dlg.showModal();
    window.FDCLetter.fontsReady().then(dlg.paint); dlg.paint();
    setTimeout(() => f.to.focus(), 50);
  });
}

